import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetContactDuplicateStatus as GetContactDuplicateStatusQuery,
    GetContactDuplicateStatusVariables,
    ContactDuplicateFragment,
} from 'nutshell-graphql-types';

import GET_CONTACT_DUPLICATE_STATUS from '../queries/get-contact-duplicate-status.graphql';

export function useGetContactDuplicateStatus(contactId: string): {
    contactDuplicateStatus: ContactDuplicateFragment | null;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<
        GetContactDuplicateStatusQuery,
        GetContactDuplicateStatusVariables
    >(GET_CONTACT_DUPLICATE_STATUS, {
        variables: {id: contactId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    });

    return {
        contactDuplicateStatus: data?.contact ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
